/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_RetireInputs */



/**
* | output |
* | --- |
* | "Retire" |
*
* @param {Promo_RetireInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_retire = /** @type {((inputs?: Promo_RetireInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_RetireInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retirar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Retirar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ritira")
	return /** @type {LocalizedString} */ ("Retire")
});